/* TAKEANAP — Set Product V2 (expanded bundle selection) */
(function () {
  'use strict';

  var uid = 0;
  var COLOR_OPTION_NAMES = ['צבע', 'color', 'colour', 'גוון'];
  var CTA_ADD = 'הוספה לסט';
  var CTA_ADDED = '✓ נוסף לסט';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '{{ amount }} ₪';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholderRegex);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  function isRealValue(val) {
    return !!val && String(val).trim() !== '' && val !== 'Default Title';
  }

  function sizeOptionIndex(data) {
    if (!data.options || !data.options.length) return null;
    for (var i = 0; i < data.options.length; i++) {
      var name = String(data.options[i]).trim().toLowerCase();
      if (name === 'title') continue;
      if (COLOR_OPTION_NAMES.indexOf(name) !== -1) continue;
      return i;
    }
    return null;
  }

  function variantSize(data, variant) {
    var idx = sizeOptionIndex(data);
    if (idx == null) return null;
    var val = variant['option' + (idx + 1)];
    return isRealValue(val) ? val : null;
  }

  ready(function () {
    var root = document.querySelector('[data-set-v2]');
    if (!root) return;

    var summary = root.querySelector('[data-summary]');
    var summaryItems = root.querySelector('[data-summary-items]');
    var atcBtn = document.querySelector('.spv2-atc');
    var infoWrapper = document.querySelector('.product-info__block-list.set-v2');

    function getScript(group, productId) {
      return group.querySelector('script[data-spv2-json][data-product-id="' + productId + '"]');
    }

    function getData(group, productId) {
      var script = getScript(group, productId);
      if (!script) return null;
      if (!script._parsed) { try { script._parsed = JSON.parse(script.textContent); } catch (e) { return null; } }
      return script._parsed;
    }

    function getAllData(group) {
      if (!group._allData) {
        group._allData = [];
        group.querySelectorAll('script[data-spv2-json]').forEach(function (s) {
          try { group._allData.push(JSON.parse(s.textContent)); } catch (e) {}
        });
      }
      return group._allData;
    }

    function isNoSize(data) {
      if (sizeOptionIndex(data) == null) return true;
      for (var i = 0; i < data.variants.length; i++) {
        if (variantSize(data, data.variants[i])) return false;
      }
      return true;
    }

    function groupSizes(group) {
      if (!group._sizes) {
        var titles = [];
        getAllData(group).forEach(function (data) {
          if (isNoSize(data)) return;
          data.variants.forEach(function (v) {
            var size = variantSize(data, v);
            if (size && titles.indexOf(size) === -1) titles.push(size);
          });
        });
        group._sizes = titles;
      }
      return group._sizes;
    }

    function sizeAvailable(group, title, productId) {
      var datas = productId ? [getData(group, productId)] : getAllData(group);
      for (var i = 0; i < datas.length; i++) {
        var data = datas[i];
        if (!data || isNoSize(data)) continue;
        for (var j = 0; j < data.variants.length; j++) {
          if (variantSize(data, data.variants[j]) === title && data.variants[j].available) return true;
        }
      }
      return false;
    }

    function getColorName(group, productId) {
      var s = getScript(group, productId);
      return s ? (s.getAttribute('data-color-name') || '') : '';
    }

    function setupGroup(group) {
      var rowsWrap = group.querySelector('[data-rows]');
      var firstRow = rowsWrap.querySelector('[data-row]');
      group._pristine = firstRow.cloneNode(true);
      bindRow(group, firstRow);
      group.querySelector('[data-add-row]').addEventListener('click', function () {
        var nr = group._pristine.cloneNode(true);
        rowsWrap.appendChild(nr);
        bindRow(group, nr);
        refreshRowControls(group);
        nr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    function bindRow(group, row) {
      row.dataset.uid = ++uid;
      row.querySelectorAll('[data-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () { selectColor(group, row, btn); });
      });
      row.querySelector('[data-qty-plus]').addEventListener('click', function () { changeQty(group, row, 1); });
      row.querySelector('[data-qty-minus]').addEventListener('click', function () { changeQty(group, row, -1); });
      var input = row.querySelector('[data-qty-input]');
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        if (v > 99) v = 99;
        input.value = v;
        updateRowPrice(group, row);
        updateSummary();
      });
      row.querySelector('[data-remove-row]').addEventListener('click', function () { removeRow(group, row); });
      renderSizes(group, row);
    }

    function renderSizes(group, row) {
      var sizesBlock = row.querySelector('[data-sizes-block]');
      var sizesWrap = row.querySelector('[data-sizes]');
      var titles = groupSizes(group);
      sizesWrap.innerHTML = '';
      if (!titles.length) { sizesBlock.hidden = true; return; }
      titles.forEach(function (title) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'spv2-size';
        pill.textContent = title;
        pill.setAttribute('data-size-title', title);
        if (!sizeAvailable(group, title, null)) pill.classList.add('is-disabled');
        pill.addEventListener('click', function () { selectSizeTitle(group, row, pill); });
        sizesWrap.appendChild(pill);
      });
      sizesBlock.hidden = false;
    }

    function updateSizeAvailability(group, row) {
      var productId = row.dataset.productId || null;
      row.querySelectorAll('.spv2-size').forEach(function (pill) {
        var title = pill.getAttribute('data-size-title');
        var ok = sizeAvailable(group, title, productId);
        pill.classList.toggle('is-disabled', !ok);
        if (!ok && pill.classList.contains('is-selected')) {
          pill.classList.remove('is-selected');
          delete row.dataset.sizeTitle;
        }
      });
    }

    function removeRow(group, row) {
      var rowsWrap = group.querySelector('[data-rows]');
      if (rowsWrap.querySelectorAll('[data-row]').length > 1) {
        row.remove();
      } else {
        var nr = group._pristine.cloneNode(true);
        rowsWrap.replaceChild(nr, row);
        bindRow(group, nr);
      }
      refreshRowControls(group);
      updateSummary();
    }

    function refreshRowControls(group) {
      var rows = group.querySelectorAll('[data-row]');
      rows.forEach(function (r) {
        var btn = r.querySelector('[data-remove-row]');
        if (btn) btn.hidden = !(rows.length > 1 || r.dataset.variantId);
      });
    }

    function selectColor(group, row, btn) {
      var productId = btn.getAttribute('data-product-id');
      var isCard = btn.classList.contains('spv2-single-card');

      if (isCard && row.dataset.productId === productId && row.dataset.variantId) {
        removeRow(group, row);
        return;
      }

      row.querySelectorAll('[data-swatch]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      row.dataset.productId = productId;
      delete row.dataset.variantId;

      var colorRow = row.querySelector('.spv2-color-row');
      if (colorRow) colorRow.classList.add('has-selection');

      var colorEl = row.querySelector('[data-selected-color]');
      if (colorEl) colorEl.textContent = getColorName(group, productId);

      var data = getData(group, productId);
      if (!data) return;

      var sizesBlock = row.querySelector('[data-sizes-block]');

      if (isNoSize(data)) {
        sizesBlock.hidden = true;
        var firstAvailable = null;
        for (var i = 0; i < data.variants.length; i++) { if (data.variants[i].available) { firstAvailable = data.variants[i]; break; } }
        if (firstAvailable) row.dataset.variantId = firstAvailable.id;
        updateRowPrice(group, row);
      } else {
        sizesBlock.hidden = false;
        updateSizeAvailability(group, row);
        tryResolve(group, row);
      }
      updateSummary();
      refreshRowControls(group);
    }

    function selectSizeTitle(group, row, pill) {
      if (pill.classList.contains('is-disabled')) return;
      row.querySelectorAll('.spv2-size').forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      row.dataset.sizeTitle = pill.getAttribute('data-size-title');
      tryResolve(group, row);
      updateSummary();
      refreshRowControls(group);
    }

    function tryResolve(group, row) {
      delete row.dataset.variantId;
      if (!row.dataset.productId || !row.dataset.sizeTitle) { updateRowPrice(group, row); return; }
      var data = getData(group, row.dataset.productId);
      if (!data) { updateRowPrice(group, row); return; }
      for (var i = 0; i < data.variants.length; i++) {
        if (variantSize(data, data.variants[i]) === row.dataset.sizeTitle && data.variants[i].available) {
          row.dataset.variantId = data.variants[i].id;
          break;
        }
      }
      updateRowPrice(group, row);
    }

    function changeQty(group, row, delta) {
      var input = row.querySelector('[data-qty-input]');
      var v = (parseInt(input.value, 10) || 1) + delta;
      if (v < 1) v = 1;
      if (v > 99) v = 99;
      input.value = v;
      updateRowPrice(group, row);
      updateSummary();
    }

    function rowState(group, row) {
      if (!row.dataset.productId || !row.dataset.variantId) return null;
      var data = getData(group, row.dataset.productId);
      if (!data) return null;
      var variant = data.variants.filter(function (v) { return String(v.id) === String(row.dataset.variantId); })[0];
      if (!variant) return null;
      var qty = parseInt(row.querySelector('[data-qty-input]').value, 10) || 1;
      return { row: row, group: group, data: data, variant: variant, qty: qty, colorName: getColorName(group, row.dataset.productId), sizeName: variantSize(data, variant) };
    }

    function updateRowPrice(group, row) {
      var st = rowState(group, row);
      var el = row.querySelector('[data-line-price]');
      if (!el) return;
      if (!st) { el.innerHTML = ''; return; }
      var html = '<span class="spv2-price">' + formatMoney(st.variant.price * st.qty) + '</span>';
      if (st.variant.compare_at_price && st.variant.compare_at_price > st.variant.price) {
        html += ' <s class="spv2-compare">' + formatMoney(st.variant.compare_at_price * st.qty) + '</s>';
      }
      el.innerHTML = html;
    }

    function updateCards() {
      root.querySelectorAll('[data-row]').forEach(function (row) {
        var card = row.querySelector('.spv2-single-card');
        if (!card) return;
        var added = !!row.dataset.variantId;
        card.classList.toggle('is-added', added);
        var cta = card.querySelector('[data-cta]');
        if (cta) cta.textContent = added ? CTA_ADDED : CTA_ADD;
      });
    }

    function collectStates() {
      var states = [];
      root.querySelectorAll('[data-group]').forEach(function (group) {
        group.querySelectorAll('[data-row]').forEach(function (row) {
          var st = rowState(group, row);
          if (st) states.push(st);
        });
        var addRow = group.querySelector('[data-add-row]');
        if (addRow) {
          var singleNoSize = group.hasAttribute('data-single-nosize');
          addRow.hidden = singleNoSize || !group.querySelector('[data-row][data-variant-id]');
        }
      });
      return states;
    }

    function updateSummary() {
      var states = collectStates();
      updateCards();
      summaryItems.innerHTML = '';
      var total = 0, compareTotal = 0;
      states.forEach(function (st) {
        total += st.variant.price * st.qty;
        compareTotal += (st.variant.compare_at_price && st.variant.compare_at_price > st.variant.price ? st.variant.compare_at_price : st.variant.price) * st.qty;
        var img = (st.variant.featured_image && st.variant.featured_image.src) || st.data.featured_image || '';
        var card = document.createElement('div');
        card.className = 'spv2-card';
        card.innerHTML =
          '<div class="spv2-card-media">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<button type="button" class="spv2-card-remove" aria-label="הסרה">&times;</button>' +
          '</div>' +
          '<a class="spv2-card-title" href="/products/' + st.data.handle + '">' + st.data.title + '</a>' +
          (st.sizeName ? '<p class="spv2-card-variant">' + st.sizeName + '</p>' : '') +
          '<p class="spv2-card-qty">כמות: ' + st.qty + '</p>' +
          '<p class="spv2-card-price">' + formatMoney(st.variant.price * st.qty) + '</p>';
        card.querySelector('.spv2-card-remove').addEventListener('click', function () {
          removeRow(st.group, st.row);
        });
        summaryItems.appendChild(card);
      });

      summary.hidden = states.length === 0;

      var totalEl = document.querySelector('.spv2-total-price');
      var savedEl = document.querySelector('.spv2-saved-price');
      var savedWrap = document.querySelector('.spv2-saved');
      if (totalEl) totalEl.textContent = formatMoney(total);
      var saved = compareTotal - total;
      if (savedWrap) {
        savedWrap.style.display = saved > 0 ? '' : 'none';
        if (savedEl) savedEl.textContent = formatMoney(saved);
      }
      if (atcBtn) atcBtn.classList.toggle('disabled', states.length === 0);
    }

    root.querySelectorAll('[data-group]').forEach(setupGroup);

    var greetingToggle = document.getElementById('spv2FormEnable');
    if (greetingToggle) {
      greetingToggle.addEventListener('change', function () {
        var form = document.querySelector('.custom_form_set_product');
        if (form) form.classList.toggle('active', greetingToggle.checked);
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.classList.contains('disabled') || atcBtn.classList.contains('is-loading')) return;
        var states = collectStates();
        if (!states.length) return;

        var titleEl = document.querySelector('.product-info__block-item .product-title');
        var productTitle = titleEl ? titleEl.textContent.trim() : '';
        var bundleWrapper = infoWrapper || document.querySelector('.product-info__block-list.set');
        var bundleId = bundleWrapper ? bundleWrapper.getAttribute('data-bundle-id') : '';
        var bundleIcon = bundleWrapper ? bundleWrapper.getAttribute('data-bundle-icon') : '';

        var sender = document.getElementById('senderName');
        var receiver = document.getElementById('receiverName');
        var message = document.getElementById('message');
        var greetingCard = document.querySelector('[data-greeting-card-input]');
        var optionsWrapper = document.querySelector('[data-greeting-options-wrapper]');

        var note = '';
        if (greetingCard && greetingCard.checked) {
          var senderValue = sender ? sender.value.trim() : '';
          var receiverValue = receiver ? receiver.value.trim() : '';
          var messageValue = message ? message.value.trim() : '';
          var invalid = false;
          [[sender, senderValue], [receiver, receiverValue], [message, messageValue]].forEach(function (pair) {
            if (!pair[0]) return;
            var err = pair[0].closest('div') ? pair[0].closest('div').querySelector('p.error') : null;
            if (!pair[1]) { if (err) err.style.display = 'block'; invalid = true; }
            else if (err) { err.style.display = 'none'; }
          });
          if (invalid) return;
          var noteParts = [];
          noteParts.push(greetingCard.getAttribute('data-label') + ': ' + greetingCard.value);
          if (sender) noteParts.push(sender.getAttribute('data-label') + ': ' + senderValue);
          if (receiver) noteParts.push(receiver.getAttribute('data-label') + ': ' + receiverValue);
          if (message) noteParts.push(message.getAttribute('data-label') + ': ' + messageValue);
          if (optionsWrapper) {
            var caseInput = optionsWrapper.querySelector('input[name="case_type"]:checked');
            noteParts.push(optionsWrapper.getAttribute('data-label') + ': ' + (caseInput ? caseInput.value : ''));
          }
          note = '[ADDITIONAL_NOTES]' + noteParts.join(' | ') + '[/ADDITIONAL_NOTES]';
        }

        var items = states.map(function (st) {
          return {
            id: st.variant.id,
            quantity: st.qty,
            properties: {
              _bundle_main_title: productTitle,
              _bundle_product: 'yes',
              _bundle_id: bundleId,
              _bundle_icon: bundleIcon
            }
          };
        });

        atcBtn.classList.add('is-loading');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); }).then(function () {
          if (note) {
            return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note }) });
          }
        }).then(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          atcBtn.classList.remove('is-loading');
          if (window.PlanetDataset && window.PlanetDataset.SmartCart && window.PlanetDataset.SmartCart.methods && window.PlanetDataset.SmartCart.methods.openDrawer) {
            window.PlanetDataset.SmartCart.methods.openDrawer(true);
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              var drawer = document.querySelector('#cart-drawer');
              if (drawer && drawer.show) drawer.show();
            }, 500);
          }
        }).catch(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          atcBtn.classList.remove('is-loading');
        });
      });
    }

    updateSummary();
  });
})();
